import { JSX } from "react";
import { BasicRecord } from "./basicRecord";
import { BasicTable } from "./BasicTable";
import { SummaryResultNetworkType, SummaryResultType } from "./enumerations";

interface BySpecialtyProps {
  providersEndpointFunc: (networkType: SummaryResultNetworkType, resultType: SummaryResultType, key: string) => string;
  records: BasicRecord[];
}

const BySpecialty = (props: BySpecialtyProps): JSX.Element => <BasicTable {...props} records={props.records} tableName="Specialty" />;

export { BySpecialty };
